<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-6">
      <div class="card full-height bg-ligth">
        <div class="card-header">
          <h3 class="mb-0">{{ lista_campos != '' ? 'Editar' : 'Criar' }} Tipos de Produtos</h3>
        </div>
        <div class="card-body">
          <div class="form">
          
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Titulo:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.titulo"
                    placeholder="Digite o nome..."
                />
              </div>
                   <div class="col-md-12">
                <label class="col-md-12">Conteudo:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.conteudo"
                    placeholder="Digite o nome..."
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                    @click="confirm(lista_campos == '' ? 'cria' : 'edita')"
                    class="btn btn-primary"
                    :disabled="verif"
                >
                  Salvar
                  <b-spinner
                      v-show="verif"
                      small
                      variant="dark"
                      type="grow"
                      label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fireAlert} from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        titulo: "",
        conteudo:"",  
      },
      verif: false,
    };
  },
  created() {
    this.preenxerCampos();
  },
  computed: {
  
  
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.aviso.mensagem_alert;
    },
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação  ` + tipo + ` uma Aviso no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("aviso/create_aviso", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'aviso'
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("aviso/update_aviso", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'aviso'
      });
    },

    preenxerCampos() {
      if (this.lista_campos != "")
        this.form = {
          id: this.lista_campos.id,
          conteudo: this.lista_campos.conteudo,
          titulo: this.lista_campos.titulo,
        
          descricao: this.lista_campos.descricao,
          status: this.lista_campos.status,
          user_in: this.lista_campos.user_in,
          user_up: this.lista_campos.user_up,
          filial_id: this.lista_campos.filial_id,
      
        };
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: rgb(167, 183, 255);
}
</style>